const state = () => ({
  topicStates: {},
});

const getters = {
  all: state => Object.keys(state.topicStates).map(id => state.topicStates[id]),
  topicStates: state => state.topicStates,
};

const mutations = {
  delete(state, topicIds) {
    topicIds.forEach(topicId => {
      delete state.topicStates[topicId];
    });
  },
  set(state, states) {
    states.forEach(topicState => {
      state.topicStates[topicState.topicId] = topicState;
    });
  },
  reset(state) {
    state.topicStates = {};
  },
};

const actions = {
  send({ commit, rootGetters }, topic) {
    let params = {
      mobileCreatedAt: Date.now(),
      topicId: topic.id,
    };

    commit('set', [params]);
    return rootGetters['session/ajax'].post('/topic_states', params);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
